import { type PropsWithChildren } from "react";

export enum TextAlignment {
  LEFT = "left",
  CENTER = "center",
  RIGHT = "right",
  INHERIT = "inherit",
}

export enum Variant {
  SMALL = "small",
  MEDIUM = "medium",
  XLARGE = "extra-large",
  PRIMARY = "primary",
  LINK = "link",
}

export const textAlignmentValues: string[] = Object.values(TextAlignment);
export const variantValues: string[] = Object.values(Variant);

export interface ITextProps
  extends Partial<PropsWithChildren<Record<string, unknown>>> {
  textColor?: string;
  className?: string;
  /** How the text should be aligned */
  alignment?: TextAlignment;
  /** Which HTML tag to render the text in */
  tag?: keyof HTMLElementTagNameMap;
}

export interface BodyTextProps extends ITextProps {
  variant?: Variant.LINK;
}
